export default __webpack_public_path__ + "static/media/nightwatch.f43e8e76.svg";